export default __webpack_public_path__ + "static/media/splash-icon.8a8fbc65.png";